import { ButtonProps } from '@design-system/button';
import { CarouselProps } from '@design-system/carousel';
import { CtaBlockProps } from '@design-system/cta-block';
import { FluidGridProps } from '@design-system/fluid-grid';
import { PageBlockProps } from '@design-system/page-block';
import { PaginationLabelsProps } from '@design-system/pagination';
import { WhereToBuyProps } from '@design-system/where-to-buy';
import { ReactElement, ReactNode } from 'react';

import {
  Filter,
  FilterMapperResult,
  ItemListingTypes,
  ItemTypes,
} from '~/mappers/itemListing/models';
import { TypographyUI } from '~/mappers/typography/models';
import { SelectEvents } from '~/types/common';

export interface ItemListingProps {
  allLoaded?: boolean;
  onAllItemsLoaded?: () => void;
  typeName?: string;
  fluidGrid: FluidGridProps;
  pageBlock: PageBlockProps;
  items: ReactNode[];
  rawItems: ItemListingTypes;
  type: string;
  currentPageUid: string;
  uid: string;
  id?: string;
  pagination?: PaginationLabelsProps;
  loadMoreButton?: ButtonProps;
  initialNumberArticles?: number;
  filterSettings?: FilterMapperResult;
  content_type?: string;
  onItemsLoaded?: (newItems: any[]) => void;
  selectEvents?: SelectEvents;
  whereToBuyData?: WhereToBuyProps;
  itemsName?: string;
  itemsAmount?: number;
  data?: ItemTypes[];
  filters?: Filter[];
  text?: string;
  typographyUI?: TypographyUI;
}

export interface ItemListingCarouselProps {
  pageBlock: PageBlockProps;
  items: ReactElement[];
  carousel: CarouselProps;
  fancySlider?: boolean;
  id?: string;
  showMore?: CtaBlockProps;
  uid: string;
}

export enum FilterOption {
  SideFilters = 'side-filters',
  TopFilters = 'top-filters',
}
